import React, { useState, useEffect } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import theme from "@theme";
import SC from "./style";
import InfiniteScroll from "react-infinite-scroll-component";
import { Global } from "@emotion/react";

const DropdownList = (props) => {
  const {
    fetchOptions = [],
    value = "Select",
    onChange = () => {},
    name = "",
    disabled = false,
    loader = "",
    virtualScroll = false,
    label,
    icon,
    style,
    sx,
    border = false,
    para,
  } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [displayedOptions, setDisplayedOptions] = useState([]);
  const [allOptions, setAllOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const loadOptions = async () => {
    const options = await fetchOptions(currentPage);
    if (options) {
      if (virtualScroll) {
        setDisplayedOptions((prevTaskData) => [...prevTaskData, ...options]);
        setAllOptions((prevTaskData) => [...prevTaskData, ...options]);
      } else {
        setDisplayedOptions(options);
        setAllOptions(options);
      }
    } else {
      setDisplayedOptions([]);
      setAllOptions([]);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    setDisplayedOptions([]);
    setAllOptions([]);
    loadOptions();
  }, [fetchOptions]);

  useEffect(() => {
    loadOptions();
  }, [currentPage]);

  useEffect(() => {
    const filtered =
      allOptions &&
      allOptions.filter((option) =>
        option?.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    setDisplayedOptions(filtered);
  }, [searchTerm, allOptions]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleOptionClick = (option) => {
    onChange(option, name);
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onEndScroll = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  return (
    <>
      <Global styles={SC.globalStyles} />
      <div style={{ position: "relative", width: "200px" }}>
        <label
          htmlFor="basic-button"
          style={{
            position: "absolute",
            top: "-6px",
            left: "10px",
            backgroundColor: "white",
            padding: "0 5px",
            fontSize: "10px",
            color: theme.colors.black,
            zIndex: 1,
          }}
        >
          {label}
        </label>

        <div
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          style={{
            ...style,
            display: "flex",
            alignItems: "center",
            color: "black",
            textTransform: "capitalize",
            fontWeight: "none",
            cursor: "pointer",
            marginTop: "0px",
            position: "relative",
            justifyContent: "space-between",
            flex: "1",
            overflow: "hidden",
            ...(border && {
              border: `1px solid ${theme.colors.themeColor}`,
              padding: "5px",
              borderRadius: "4px",
              fontSize: "12px",
              minWidth: "150px",
              height: "29px",
              marginRight: "10px",
              marginBlock: "0px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }),
          }}
          disabled={disabled}
        >
          <p
            style={{
              ...para,
              margin: "0",
              flex: "1",
              overflow: "hidden",
              textOverflow: "ellipsis",
              justifyContent: "center",
            }}
          >
            {value || "Select"}
          </p>
          <span style={{ marginTop: "5px", whiteSpace: "nowrap" }}>
            {" "}
            {icon}
          </span>
        </div>
      </div>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <input
          placeholder="Search"
          value={searchTerm}
          onChange={handleSearchChange}
          style={{
            width: "90%",
            padding: "4px",
            alignContent: "center",
            alignItems: "center",
            borderRadius: "3px",
            border: "1px solid lightgray",
            margin: "0px 0px 5px 10px",
          }}
        />
        <SC.ActivityBox id={"epicDropdown"}>
          <InfiniteScroll
            dataLength={displayedOptions.length}
            next={onEndScroll}
            hasMore={true}
            loader={loader}
            scrollableTarget="epicDropdown"
          >
            {displayedOptions.length > 0 ? (
              displayedOptions.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                  sx={{
                    ...sx,
                    borderTop: `1px solid ${theme.colors.bordertask}`,
                    fontSize: "12px",
                    width: "180px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  onClick={() => handleOptionClick(option)}
                >
                  {option.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No data available</MenuItem>
            )}
          </InfiniteScroll>
        </SC.ActivityBox>
      </Menu>
    </>
  );
};

export default DropdownList;
